import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'date-range-selector',
  templateUrl: './date-range-selector.html',
  styleUrl: './date-range-selector.scss',
  standalone: false,
})
export class DateRangeSelectorComponent {

  @Input() public minDate: Date | null = null;
  @Input() public maxDate: Date | null = null;
  @Input() public selectedDate: Date | null = null;
  @Input() public showWeeks: boolean = false;
  @Output() public selectedDateChange = new EventEmitter<Date | null>();

  public readonly rangeLabelsId = 'dateRangeLabels';

  get dateLabels(): Date[] {
    if (!this.minDate || !this.maxDate || this.maxDate < this.minDate) {
      return [];
    }

    const minTime = this.minDate.getTime();
    const maxTime = this.maxDate.getTime();
    const interval = (maxTime - minTime) / 4;

    return [0, 1, 2, 3, 4].map(index => new Date(minTime + interval * index));
  }

  get selectedDateTimestamp(): number | null {
    return this.selectedDate?.getTime() ?? this.minDate?.getTime() ?? null;
  }

  get minDateTimestamp(): number | null {
    return this.minDate?.getTime() ?? null;
  }

  get maxDateTimestamp(): number | null {
    return this.maxDate?.getTime() ?? null;
  }

  get todayPositionPercent(): number | null {
    if (!this.minDate || !this.maxDate || this.maxDate <= this.minDate) {
      return null;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const minTime = this.minDate.getTime();
    const maxTime = this.maxDate.getTime();

    if (today.getTime() < minTime || today.getTime() > maxTime) {
      return null;
    }

    return ((today.getTime() - minTime) / (maxTime - minTime)) * 100;
  }

  onDateChanged(event: Event): void {
    const value = Number((event.target as HTMLInputElement).value);
    if (Number.isNaN(value)) {
      this.selectedDateChange.emit(null);
      return;
    }

    const selectedDate = new Date(value);
    selectedDate.setHours(0, 0, 0, 0);
    this.selectedDateChange.emit(selectedDate);
  }

  formatDate(date: Date): string {
    const today = new Date();
    if (date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate()) {
      return 'Today';
    }

    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  }

}
